export const WIDGET_MIN_WIDTH = 420;
